module.exports = __webpack_public_path__ + "img/sq.3f3f02c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sq.png
// module id = Y3Kw
// module chunks = 0 1 2 3